import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { SettingsIcon } from '../../Icons/Icons';
import EditNavPopup from '../../../container/dashboard/Popup/EditNavPopup'

function Settings() {
  const edit = useSelector((state) => state.edit.edit);
  const localData = useSelector((state) => state.localRedux);
  const storeSubcription = localData.subcription
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [linkUrl, setLinkUrl] = useState()
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;
  const handleChange = (url) => {
    if (storeSubcription?.isActive) {
      if (edit) {
        setConfirmPopup(true)
        setLinkUrl(url)
      }
    }
    else {
      message.info("Your subscription is not active. Please renew to continue");
    }
  };
  return (
    <>
      <div className="settings" title='Settings'>
        <Link to={(storeSubcription?.isActive && !edit) ? "/Home/settings" : combinedUrl} className="head-example" onClick={() => handleChange("/Home/settings")}>
          <SettingsIcon height={24} width={20} />
        </Link>
      </div>
      {confirmPopup && <EditNavPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} linkUrl={{ url: linkUrl, type: "Normal" }} />}
    </>
  );
}

export default Settings;
